import { useCallbackObservable, useObservable } from 'react-use-observable';

import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import ordersService from 'v2/services/orders';

import List from './list';

const ModalTrackingCodes = () => {
  const [open] = useObservable(() => ordersService.getModalTrackingCodes(), []);
  const [closeModal] = useCallbackObservable(() => ordersService.closeModalTrackingCodes(), []);

  return (
    <Modal
      width={1024}
      open={!!open}
      onCancel={closeModal}
      destroyOnHidden
      title={
        <>
          Status dos pedidos: AGUARDANDO ENVIO
          <p className='mt-1 text-sm text-[#f50057]'>
            Ao enviar o código de rastreio o status da entrega será atualizado para <b>ENVIADO</b> automaticamente.
          </p>
        </>
      }
      closeIcon={<CloseOutlined className='text-primary' />}
      footer={
        <div className='flex justify-end'>
          <Button onClick={closeModal} type='primary'>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='w-full rounded-sm bg-white'>{open && <List />}</div>
    </Modal>
  );
};
export default ModalTrackingCodes;
